import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useGoBack } from '@/common/hooks/useGoBack'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteMaintenanceSolicitation } from '@/features/privateCompanies/hooks/maintenanceSolicitations/useDeleteMaintenanceSolicitation'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

export const ModalDeleteMaintenanceSolicitation = () => {
  const { companyId, id } = useParams()
  const goBack = useGoBack()
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['maintenanceSolicitations'] })
    goBack({ fallback: `/companies/${companyId}/maintenance/solicitations`, searchLastRouteFromFallback: true })
  }

  const { mutate: deleteCompanyBranchAdditionalDocument, isPending: deleteCompanyBranchAdditionalDocumentIsPending } =
    useDeleteMaintenanceSolicitation({
      id: id || '',
      onSuccess,
      onError: FormTransformers.errorsTransformer({ setMessages }),
    })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={(value) => setIsOpen(value)}
        Trigger={
          <Button
            name="delete_maintenance_solicitation"
            variant="outline-error"
            operationKlassToCheckPermission="Admin::Maintenance::Solicitations::Destroy"
          >
            Deletar
          </Button>
        }
        triggerAsChild
        title="Confirmar Exclusão"
        subtitle="Tem certeza que deseja excluir esta solicitação de manutenção? Esta ação não pode ser desfeita."
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-sm"
        showClose={false}
        useCancellableFooter
        disabled={deleteCompanyBranchAdditionalDocumentIsPending}
        confirmButtonIsLoading={deleteCompanyBranchAdditionalDocumentIsPending}
        onConfirm={() => deleteCompanyBranchAdditionalDocument()}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
